export const TaskStatus = {
  QUEUED: 'QUEUED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
} as const;

export const TaskResolution = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
} as const;

export const TaskPipeline = {
  PROCESSING: 'PROCESSING',
  INTERROGATION: 'INTERROGATION',
  AI_EXTRACTION: 'AI_EXTRACTION',
} as const;

/**
 * The object that tasks are associated to (PartFile, Component, Quote). These objects have an
 * entityKey that is used as the cache key in both the backend and frontend.
 */
export const TaskEntityType = {
  PART_FILE: 'partFile',
  COMPONENT: 'component',
  QUOTE: 'quote',
} as const;

/**
 * The object that is related to one or more Task entity objects via a foreignkey or
 * ManyToMany relationship i.e. quotes, quote items, components, parts, part file to
 * quotes, part masters.
 */
export const RelatedEntityType = {
  COMPONENT: 'component',
  QUOTE: 'quote',
  PART_FILE_TO_QUOTE: 'partFileToQuote',
  QUOTE_ITEM: 'quoteItem',
  PART: 'part',
  PART_MASTER: 'partMaster',
} as const;

// Partworker tasks in camel case version
export const PartWorkerTasks = {
  ADDITIVE: 'additive',
  CASTING: 'casting',
  CHANGE_THICKNESS: 'changeThickness',
  COMPONENT_NESTING: 'componentNesting',
  CONTOUR_EDIT: 'contourEdit',
  DXF_SCENE: 'dxfScene',
  EMAIL_RFQ_EXTRACTION: 'emailRfqExtraction',
  GEOMETRIC_INDEXING: 'geometricIndexing',
  HOOPS_BACKUP_PROCESSING: 'hoopsBackupProcessing',
  HOOPS_CONVERSION: 'hoopsConversion',
  HEAL_FILE: 'healFile',
  STEP_PMI_EXTRACTION: 'stepPmiExtraction',
  FILE_TO_PDF: 'fileToPdf',
  MULTI_COMPONENT_NESTING: 'multiComponentNesting',
  MULTI_COMPONENT_LINEAR_NESTING: 'multiComponentLinearNesting',
  LATHE: 'lathe',
  MILL3: 'mill3',
  NESTING_CLEANUP: 'nestingCleanup',
  NESTING: 'nesting',
  PDF_CONVERSION: 'pdfConversion',
  PRINT_OCR: 'printOcr',
  PRINT_PAGE_PARTBOT_PROCESSING: 'printPagePartbotProcessing',
  PRINT_PAGE_ENHANCED_PARTBOT_PROCESSING: 'printPageEnhancedPartbotProcessing',
  ANALYZE_DOCUMENT: 'analyzeDocument',
  CROPPED_TABLE_ANALYSIS: 'croppedTableAnalysis',
  // not a real partworker job - see partworker/constants.py's EXTRACTED_TABLE_DISMISSED
  EXTRACTED_TABLE_DISMISSED: 'extractedTableDismissed',
  PRINT_TEXT_EXTRACTION: 'printTextExtraction',
  PRINT_VECTORIZATION: 'printVectorization',
  PROCESSING: 'processing',
  SHEET_METAL: 'sheetMetal',
  SW_BACKUP_PROCESSING: 'swBackupProcessing',
  SW_CONVERSION: 'swConversion',
  MESH_TO_STL_CONVERSION: 'meshToStlConversion',
  THUMBNAIL_CREATION: 'thumbnailCreation',
  TUBE_LASER: 'tubeLaser',
  UPLOAD: 'upload',
  UNLOCK_PDF: 'unlockPdf',
  UNLOCK_ZIP: 'unlockZip',
  VECTOR_CONVERSION: 'vectorConversion',
  VIEWER_CREATION: 'viewerCreation',
  VIRUS_SCAN: 'virusScan',
  WIRE_EDM: 'wireEdm',
  ZIP_CONVERSION: 'zipConversion',
  ZIP_EXTRACTION: 'zipExtraction',
  ZIP_ANALYSIS: 'zipAnalysis',
  PACK_AND_GO_REPORT: 'packAndGoReport',
} as const;

export const ComponentTasks = {
  REQUIREMENTS_REVIEW: 'requirementsReview',
};

export const QuoteTasks = {
  BULK_RESOLVE_ACTIONS: 'bulkResolveActions',
};

export const AsyncTasks = {
  ...PartWorkerTasks,
  ...ComponentTasks,
  ...QuoteTasks,
} as const;
